import { c as _c } from "react/compiler-runtime";
import type { MemberFindItem } from '@module/apis/client-side/member/type';
import BaseSpinner from '@module/components/Spinner/BaseSpinner';
import { itemsPerPage } from '@module/constants/pagenation';
import { useMemberFindQuery } from '@module/queries/member/memberQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_MOBILE, MODAL_TYPE_PC } from '@module/types/modal/type';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import BaseCheckbox from '@pc/components/atoms/checkbox/BaseCheckbox';
import BasePagenation from '@pc/components/pagenation/BasePagenation';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@pc/components/ui/table';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
interface IdListContainerProps {
  sessKey: string;
  setPwStep: (value: number) => void;
  setPwTargetId: (value: string) => void;
}
function IdListContainer(t0) {
  const $ = _c(28);
  const {
    sessKey,
    setPwStep,
    setPwTargetId
  } = t0;
  const router = useRouter();
  const pushModal = useModalStore(_temp);
  const [currentPage, setCurrentPage] = useState(1);
  const currentPageFirstOffset = (currentPage - 1) * itemsPerPage;
  const [selectedAccount, setSelectedAccount] = useState(null);
  let t1;
  if ($[0] !== currentPageFirstOffset || $[1] !== sessKey) {
    t1 = {
      session: sessKey,
      offset: currentPageFirstOffset,
      limit: itemsPerPage
    };
    $[0] = currentPageFirstOffset;
    $[1] = sessKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    isError,
    error,
    isLoading,
    isFetching
  } = useMemberFindQuery(t1);
  let t2;
  let t3;
  if ($[3] !== data) {
    t2 = () => {
      if (!data?.list.length) {
        return;
      }
      setSelectedAccount(data.list[0]);
    };
    t3 = [data];
    $[3] = data;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  const isListEmpty = !data?.page.total;
  let t4;
  if ($[6] !== pushModal || $[7] !== router || $[8] !== selectedAccount || $[9] !== setPwStep || $[10] !== setPwTargetId) {
    t4 = () => {
      if (!selectedAccount) {
        pushModal({
          type: MODAL_TYPE_MOBILE.CONFIRM_MODAL,
          id: "IdListContainer",
          options: {
            description: "\uC544\uC774\uB514\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694."
          }
        });
        return;
      }
      if (selectedAccount.isSocial) {
        pushModal({
          type: MODAL_TYPE_MOBILE.CONFIRM_MODAL,
          id: "IdListContainer",
          options: {
            description: "SNS \uAC04\uD3B8 \uB85C\uADF8\uC778\uC744 \uC774\uC6A9\uD574 \uC8FC\uC138\uC694."
          }
        });
        return;
      }
      setPwTargetId(selectedAccount.findId);
      setPwStep(2);
      router.push("/user/find?type=pw");
    };
    $[6] = pushModal;
    $[7] = router;
    $[8] = selectedAccount;
    $[9] = setPwStep;
    $[10] = setPwTargetId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleChangePassword = t4;
  if (isLoading || isFetching) {
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex w-full justify-center"><BaseSpinner /></div>;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  if (isError) {
    let t5;
    if ($[13] !== error.message) {
      t5 = <div className="w-full text-center"><p>{error.message}</p></div>;
      $[13] = error.message;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  let t5;
  if ($[15] !== currentPage || $[16] !== currentPageFirstOffset || $[17] !== data || $[18] !== handleChangePassword || $[19] !== isListEmpty || $[20] !== pushModal || $[21] !== selectedAccount?.findId) {
    t5 = !isListEmpty && <div className="mt-[70px]"><div><p className="mb-4"><span>총 게시물{" : "}</span><span className="font-semibold">{data?.page.total}</span><span>건</span></p><Table><colgroup><col className="w-[80px]" /><col className="w-[120px]" /><col /><col className="w-[250px]" /></colgroup><TableHeader><TableRow className="h-[50px]"><TableHead /><TableHead>번호</TableHead><TableHead className="">아이디</TableHead><TableHead>가입일</TableHead></TableRow></TableHeader><TableBody>{data?.list.map((record, idx) => <TableRow key={record.joinDate}><TableCell className=""><BaseCheckbox variant="radio" label="" checked={selectedAccount?.findId === record.findId} onClick={() => setSelectedAccount(record)} /></TableCell><TableCell>{data.page.total - currentPageFirstOffset - idx}</TableCell><TableCell className="text-left">{record.findId}</TableCell><TableCell className="">{record.joinDate}</TableCell></TableRow>)}</TableBody></Table><BasePagenation currentPage={currentPage} setCurrentPage={setCurrentPage} pageData={data?.page} /></div><div className="mt-16 flex w-full justify-center gap-[8px]"><BaseButton className="mr-2" onClick={() => pushModal({
          type: MODAL_TYPE_PC.AUTH_MODAL,
          id: "IdListContainer"
        })}>로그인하기</BaseButton><BaseButton className="ml-2" onClick={handleChangePassword}>비밀번호 변경</BaseButton></div></div>;
    $[15] = currentPage;
    $[16] = currentPageFirstOffset;
    $[17] = data;
    $[18] = handleChangePassword;
    $[19] = isListEmpty;
    $[20] = pushModal;
    $[21] = selectedAccount?.findId;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== isListEmpty) {
    t6 = isListEmpty && <NotFoundDisplay text={"\uAC00\uC785\uD55C \uC544\uC774\uB514\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."} />;
    $[23] = isListEmpty;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
function _temp(state) {
  return state.pushModal;
}
export default IdListContainer;